module.exports = __webpack_public_path__ + "static/media/panel_screenshot.d23f9923.webp";